import { createSelector } from 'reselect';
import { RootState } from '../../../core/store';
import { TSubscribedMsiVessel } from '../../../user-management/subscription/subscriptionTypes';
import { selectSubscribedMsiVessels } from '../../../user-management/appSelectors';
import { ICohortVessel } from './cohortTypes';

const calculateMinValue = (dwt: number): number => {
    const factor = Math.pow(10, Math.round(Math.log10(0.2 * dwt)) - 1);
    return Math.floor(0.9 * dwt / factor) * factor;
};

const calculateMaxValue = (dwt: number): number => {
    const factor = Math.pow(10, Math.round(Math.log10(0.2 * dwt)) - 1);
    return Math.ceil(1.1 * dwt / factor) * factor;
};

const calculateIntervalRange = (minVal: number, maxVal: number): number => {
    const range = maxVal - minVal;
    return Math.pow(10, Math.round(Math.log10(range)) - 1);
};

export const vesselCohortVesselsListSelector = createSelector(
    selectSubscribedMsiVessels,
    (_: RootState, imoNumber: number) => imoNumber,
    (subscribedMsiVessels, imoNumber) => {
        const vessel = subscribedMsiVessels.find(v => v.imoNumber === imoNumber) as TSubscribedMsiVessel;
  
        const minSize = calculateMinValue(vessel.size);
        const maxSize = calculateMaxValue(vessel.size);
        const rangeSize = calculateIntervalRange(minSize, maxSize);

        const cohortVessels = subscribedMsiVessels
            .filter(v =>
                v.imoNumber !== vessel.imoNumber &&
                v.sectorId === vessel.sectorId &&
                v.size >= minSize &&
                v.size <= maxSize &&
                v.age >= vessel.age - 2 &&
                v.age <= vessel.age + 2
            )
            .map(v => ({
                imoNumber: v.imoNumber,
                name: v.vesselName,
                size: v.size,
                sizeUnit: v.sizeUnit,
                age: v.age,
                yearOfDelivery: v.yearOfDelivery,
                msiControllingEntity: v.msiControllingEntity,
                gear: v.gear,
                scrubberFitted: v.scrubberFitted,
                fuelSystem: v.fuelSystem,
            })) as ICohortVessel[];
          
            return { cohortVessels , minSize, maxSize, rangeSize }; 

    }
);

export const vesselCohortVesselSelector = createSelector(
    selectSubscribedMsiVessels,
    (_: RootState, imoNumber: number) => imoNumber,
    (subscribedMsiVessels, imoNumber) => {
        const vessel = subscribedMsiVessels.find(v => v.imoNumber === imoNumber) as TSubscribedMsiVessel;

        return ({
            imoNumber: vessel.imoNumber,
            name: vessel.vesselName,
            size: vessel.size,
            sizeUnit: vessel.sizeUnit,
            age: vessel.age,
            yearOfDelivery: vessel.yearOfDelivery
        } as ICohortVessel)
    }
);
